var l = Object.defineProperty;
var m = (r, e, o) => e in r ? l(r, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[e] = o;
var g = (r, e, o) => m(r, typeof e != "symbol" ? e + "" : e, o);
import { TOKEN_SERVICE as f } from "./main76.js";
import { Injectable as w, Inject as i } from "@webmotors/ioc";
import "./main77.js";
import { LOGGER as R } from "./main78.js";
import "./main79.js";
import "./main80.js";
import { HttpMethod as c } from "./main81.js";
import { HTTP as T } from "./main82.js";
import { CONFIG as u } from "@packages/config";
var v = Object.getOwnPropertyDescriptor, y = (r, e, o, t) => {
  for (var n = t > 1 ? void 0 : t ? v(e, o) : e, s = r.length - 1, a; s >= 0; s--)
    (a = r[s]) && (n = a(n) || n);
  return n;
}, h = (r, e) => (o, t) => e(o, t, r);
let p = class {
  constructor(r, e, o) {
    g(this, "logger");
    this.http = r, this.config = e, this.loggerFactory = o, this.logger = this.loggerFactory.create(f);
  }
  get requestBaseURL() {
    return this.config.isServerSide() ? this.config.apiPrivateURL : this.config.apiURL;
  }
  async renewRefreshToken(r) {
    if (this.logger.log("[renewRefreshToken] ", r), !r)
      throw this.logger.log("[renewRefreshToken] refreshToken não fornecido"), new Error("Refresh token não fornecido");
    try {
      const e = `${this.requestBaseURL}/v2/login/renewtoken`;
      return await this.http.request(e, {
        method: c.POST,
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ refreshToken: r })
      });
    } catch (e) {
      throw this.logger.log("[renewRefreshToken] error: ", e), new Error(`[renewRefreshToken]: ${e}`);
    }
  }
  async revokeRefreshToken(r) {
    if (!r)
      throw new Error("Usuário não fornecido");
    try {
      const e = `${this.requestBaseURL}/v2/login/signout`;
      return await this.http.request(e, {
        method: c.POST,
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ username: r })
      });
    } catch (e) {
      throw this.logger.log("[revokeRefreshToken] error: ", e), new Error(`[revokeRefreshToken]: ${e}`);
    }
  }
};
p = y([
  w(f),
  h(0, i(T)),
  h(1, i(u)),
  h(2, i(R))
], p);
export {
  p as TokenService
};
